import { Button, ExternalLinkIcon, Flex, Text } from '@buffer-mono/popcorn'

import { useCommentData } from '../context/CommentContext'

import type { JSX } from 'react'

/**
 * Placeholder for comments whose content type we can't render — e.g. TikTok
 * sticker-only comments, which the platform API returns with empty text and no
 * media. Without this they show up as blank rows, which reads as a bug.
 *
 * Shows a short label plus, when we have a `publicUrl`, a link out to the
 * comment on the source platform where the original media is viewable.
 */
export const CommentUnsupportedContent = (): JSX.Element => {
  const { publicUrl } = useCommentData()

  return (
    <Flex align="center" gap="md" data-testid="comment-unsupported-content">
      <Text color="subtle">Media type not available</Text>
      {publicUrl && (
        <Button
          as="a"
          href={publicUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="secondary"
          size="small"
        >
          <ExternalLinkIcon />
          Open Thread
        </Button>
      )}
    </Flex>
  )
}

CommentUnsupportedContent.displayName = 'CommentUnsupportedContent'
